var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_info_card"},[_vm._t("default"),_vm._l((_vm.list),function(item,index){return _c('p',{key:index,staticClass:"id_card"},[_c('span',[_vm._v(_vm._s(item.label))]),_vm._v(_vm._s(item.value || '--'))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }